import { render, staticRenderFns } from "./detail-base-info.vue?vue&type=template&id=2d86f38a&scoped=true&"
import script from "./detail-base-info.vue?vue&type=script&lang=js&"
export * from "./detail-base-info.vue?vue&type=script&lang=js&"
import style0 from "./detail-base-info.vue?vue&type=style&index=0&id=2d86f38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d86f38a",
  null
  
)

export default component.exports